module.exports = __webpack_public_path__ + "9779d9a1/img/share-icon.0f8a11b4.svg";